import React from 'react';
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Chip,
    List,
    ListItemButton,
    Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CenterCircularProgress } from '@europrocurement/flexy-components';
import { FaOptionIcon, chevronRightIcon } from '@europrocurement/l2d-icons';
import { Formalite } from '@europrocurement/l2d-domain';
import useDocumentTypeFormalities from '../../hooks/useDocumentTypeFormalities';

type DocumentTypeFormalitiesTabProps = {
    documentTypeId: number;
};

const DocumentTypeFormalitiesTab: React.FunctionComponent<DocumentTypeFormalitiesTabProps> =
    function (props) {
        const { documentTypeId } = props;
        const navigate = useNavigate();
        const { formalities, status } = useDocumentTypeFormalities(documentTypeId);

        if (status === 'idle' || status === 'loading') {
            return <CenterCircularProgress sx={{ height: '40vh' }} />;
        }

        if (status === 'failed') {
            return (
                <Typography
                    color="error"
                    sx={{ padding: '20px' }}
                >
                    Une erreur est survenue lors de la récupération des formalités rattachées.
                </Typography>
            );
        }

        const sortedFormalities = [...formalities].sort((a, b) =>
            String(a.libelle ?? '').localeCompare(String(b.libelle ?? '')),
        );

        return (
            <Card>
                <CardHeader
                    title={
                        <Typography fontWeight="bold">
                            {`Formalités rattachées (${sortedFormalities.length})`}
                        </Typography>
                    }
                />
                <CardContent>
                    {sortedFormalities.length === 0 ? (
                        <Typography color="text.gris70">
                            Aucune formalité n&apos;est rattachée à ce type de document.
                        </Typography>
                    ) : (
                        <List>
                            {sortedFormalities.map((formality: Formalite) => (
                                <ListItemButton
                                    key={formality.id}
                                    // pas optimale on préfere une navigation avec  une constante mais le module formalite est dans b2d
                                    onClick={() => navigate(`/formalites/liste/${formality.id}`)}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        borderRadius: '8px',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px',
                                        }}
                                    >
                                        <Typography color="text.gris70">
                                            {formality.libelle}
                                        </Typography>
                                        {formality.deleted ? (
                                            <Chip
                                                size="small"
                                                color="warning"
                                                label="Inactive"
                                            />
                                        ) : null}
                                    </Box>
                                    <FaOptionIcon {...chevronRightIcon.props} />
                                </ListItemButton>
                            ))}
                        </List>
                    )}
                </CardContent>
            </Card>
        );
    };

export default DocumentTypeFormalitiesTab;
